import { batch } from 'react-redux';
import { setSitePermissionData } from 'src/store/Site';
import { setTabsData } from 'src/store/Tabs';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { MENU_GROUPS } from '../maintabs/MainTabsData';
import { useTab } from './useTab';

export const useUser = () => {
  const dispatch = useAppDispatch();
  const { tabsData } = useTab();
  const roles: any = useAppSelector(state => {
    return state.roles.roles;
  });
  const { selectedApp } = useSelectedAppInfo();
  const sitePermissionData = useAppSelector(state => state.site.sitePermissionData);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const email = useAppSelector(state => state.user.user?.email);
  const loginUserName = useAppSelector(state => state.user.user?.username);

  const tabsArray: any = selectedApp !== '' ? MENU_GROUPS[selectedApp] : [];

  const tabsPermissionData =
    tabsData &&
    tabsData.map((item: any) => {
      if (roles.includes(item.permissions)) {
        return 'dataExits';
      } else {
        return false;
      }
    });

  const tabsPermissionPilData =
    tabsData &&
    tabsData.map((item: any) => {
      if (roles.includes(item.permissions)) {
        return 'dataExits';
      } else {
        return false;
      }
    });

  if (
    roles !== undefined &&
    roles !== null &&
    roles.length > 0 &&
    (tabsPermissionData || tabsPermissionPilData) &&
    (tabsPermissionPilData.includes('dataExits') || tabsPermissionData.includes('dataExits')) &&
    tabsData.length == 0
  ) {
    const filtered = tabsArray.filter((item: any) => roles.includes(item.permissions));
    const filteredData = filtered.map((item: any, indexVal: number) => {
      if (!(typeof filtered[indexVal + 1] === 'undefined')) {
        return { ...item, index: indexVal, NextButton: true };
      } else {
        return { ...item, index: indexVal };
      }
    });
    batch(() => {
      dispatch(setTabsData(filteredData));
      dispatch(setSitePermissionData(true));
    });
  } else {
    if (
      tabsData.length == 0 &&
      roles !== undefined &&
      roles !== null &&
      roles.length > 0 &&
      selectedSite &&
      selectedSite !== ''
    ) {
      dispatch(setSitePermissionData(false));
    }
  }

  const preferences = useAppSelector(state => state.user.user?.preferences);
  return { user, roles, preferences, sitePermissionData, email, loginUserName };
};
